export default function DisplaySynonyms(props) {
  return <div>{props.loopSynonyms}</div>;
}
